import {
  FemaleVoiceId,
  FemaleVoiceName,
  MaleVoiceId,
  MaleVoiceName,
} from '@/types/voice'

type Voice = {
  Female: { id: FemaleVoiceId; name: FemaleVoiceName }[]
  Male: { id: MaleVoiceId; name: MaleVoiceName }[]
}
export const Voices: Voice = {
  Female: [
    {
      id: '26',
      name: 'Alliana',
    },
    {
      id: '28',
      name: 'Cool girl',
    },
    {
      id: '31',
      name: 'Freya',
    },
    {
      id: '32',
      name: 'Glinda',
    },
    {
      id: '33',
      name: 'Gwen',
    },
    {
      id: '34',
      name: 'Janiah',
    },
    {
      id: '35',
      name: 'Joanne',
    },
    {
      id: '36',
      name: 'Marissa',
    },
    {
      id: '37',
      name: 'Martas',
    },
    {
      id: '38',
      name: 'Maryanne',
    },
    {
      id: '39',
      name: 'Mimi',
    },
    {
      id: '40',
      name: 'Mrs Novella',
    },
    {
      id: '42',
      name: 'Nicole',
    },
    {
      id: '43',
      name: 'Olivia',
    },
    {
      id: '44',
      name: 'Patricia',
    },
    {
      id: '45',
      name: 'Posie',
    },
    {
      id: '47',
      name: 'Shianne',
    },
    {
      id: '48',
      name: 'Sophia',
    },
    {
      id: '50',
      name: 'Tonia',
    },
    {
      id: '51',
      name: 'Nova',
    },
  ],
  Male: [
    {
      id: '0',
      name: 'Andy',
    },
    {
      id: '1',
      name: 'Armando',
    },
    {
      id: '2',
      name: 'Brian',
    },
    {
      id: '3',
      name: 'Brug',
    },
    {
      id: '4',
      name: 'Carl',
    },
    {
      id: '6',
      name: 'Cody',
    },
    {
      id: '7',
      name: 'Danny',
    },
    {
      id: '8',
      name: 'Ed',
    },
    {
      id: '9',
      name: 'Ethan',
    },
    {
      id: '12',
      name: 'Giovanni',
    },
    {
      id: '13',
      name: 'Guy',
    },
    {
      id: '14',
      name: 'Jake',
    },
    {
      id: '17',
      name: 'Neil',
    },
    {
      id: '18',
      name: 'Nick Colter',
    },
    {
      id: '19',
      name: 'Patrick',
    },
    {
      id: '20',
      name: 'Raj',
    },
    {
      id: '21',
      name: 'Ren',
    },
    {
      id: '23',
      name: 'Steven',
    },
    {
      id: '24',
      name: 'Thomas',
    },
    {
      id: '25',
      name: 'Timmy',
    },
  ],
}
export const VoicesMap: Record<string, FemaleVoiceName | MaleVoiceName> =
  Object.fromEntries([
    ...Voices.Female.map((item) => [item.id, item.name]),
    ...Voices.Male.map((item) => [item.id, item.name]),
  ])
export const DEFAULT_GREETING =
  'Welcome to tipsy. You can chat with me about everything.'
